import { isNonNullable } from 'lib/array/arrayUtils'
import { objectEntries } from 'lib/object/objectUtils'

export function mergeFees(otherFares: Array<App.Checkout.OtherFees>): App.Checkout.OtherFees {
  return otherFares.filter(isNonNullable).reduce<App.Checkout.OtherFees>((merged, fares) => {
    objectEntries(fares).forEach(([key, value]) => {
      if (!value) {
        return merged
      }

      if (!merged[key]) {
        merged[key] = value
        return merged
      }

      merged[key] += value
    })
    return merged
  }, {})
}
